import { Component, OnInit, ElementRef, ViewChild, Renderer2, ChangeDetectorRef } from '@angular/core';
import { DocumentsService } from '../_services/documents.service';
import { Location } from '@angular/common';
import { DynamicTableService } from '../_services/dynamic-table.service';
import { map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfService } from '../_services/pdf.service';
import { User } from '../_models/user';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AppService } from '../_services/app.service';
import { AuthService } from '../_services/auth.service';
import { FilterService } from '../_services/filter.service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { Sign } from '../_models/sign';
import { FieldAlreadyExistsError } from 'pdf-lib';
import { ErrorDiagnosticService } from '../_services/error-diagnostic.service';
import { TypeEntity } from '../shared/enums/type-entity';

@Component({
  standalone: false,
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.scss']
})
export class SignComponent implements OnInit {
  currentUser: User;
  currentLocation: any;
  loading: boolean = false;

  @ViewChild('sign', { static: true }) sign: ElementRef;
  @ViewChild('container', { static: true }) container: ElementRef;
  @ViewChild('mailSender', { static: true }) mailSender;
  @ViewChild('iframe', { static: true }) iframe: ElementRef;
  signed: boolean = false;

  documents = [];
  pdfs = [];

  columnsConfig$;
  currentSign: string;
  today: string = '';
  typeEntityFilter;

  onPreview: boolean = false;
  postSign: boolean = false;
  sending: boolean = false;
  signAll: boolean = false;
  allSigned: boolean = false;
  signAllPages: boolean = false;

  // Sign variables
  signList: Array<Sign> = [];
  //tenarisSign64: string = '';
  //driversSign64: string = '';
  //nominateSign64: string = '';
  tenarisPrintName: string = '';
  driversPrintName: string = '';
  nominatePrintName: string = '';

  /*
  showTenarisSign: boolean = false;
  showDriversSign: boolean = false;
  showNominateSign: boolean = false;
  showTenarisPrintName: boolean = false;
  showDriversPrintName: boolean = false;
  showNominatePrintName: boolean = false;
  */
  showDate: boolean = false;

  /*
  requiredTenarisSign: boolean = false;
  requiredDriversSign: boolean = false;
  requiredNominateSign: boolean = false;
  requiredTenarisPrintName: boolean = false;
  requiredDriversPrintName: boolean = false;
  requiredNominatePrintName: boolean = false;
  */
 
  pdfToPrint: string = '';
  blobPdfToPrint: Blob;
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;

  constructor(
    private documentsService: DocumentsService,
    private dynamicTableService: DynamicTableService,
    private filterService: FilterService,
    private location: Location,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private pdfService: PdfService,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private appService: AppService,
    public authService: AuthService,
    private router: Router,
    private renderer: Renderer2,
    private errorDiagnosticService: ErrorDiagnosticService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.retrieveUserData();
    this.initData().then(data => {
      this.columnsConfig$ = this.dynamicTableService.tableColumns$.pipe(map(data => {
        return data.filter(d => d.name.toLowerCase() !== 'select');
      }));
    this.isSignedDocs();
    this.canSignAllPages();
    });
  }

  initData() {
    this.errorDiagnosticService.setMethodName('SignComponent.initData()');
    return new Promise((resolve, reject) => {
      this.documentsService.getCheckedDocuments().subscribe(data => {
        if (data.length === 0) this.goBack();
        this.documents = data;
      });
      this.documentsService.getDocumentsPdf(true).subscribe(async data => {

        this.typeEntityFilter = [TypeEntity.EbolOrigin, TypeEntity.EbolDriverOrigin];
        console.log(data);
        data.forEach(doc => {
          if(doc.SignType == null) return;
          doc.SignType.Fields = doc.SignType.Fields.filter(d => d.TypeEntity && this.typeEntityFilter.includes(d.TypeEntity));
        })

        this.pdfs = data;
        // pdfjs-dist v4 requires TypedArray; create blob URLs for viewer to avoid buffer transfer/detach
        this.pdfs.forEach(doc => {
          if (doc.pdf instanceof ArrayBuffer) doc.pdf = new Uint8Array(doc.pdf);
          doc.pdfUrl = URL.createObjectURL(new Blob([doc.pdf], { type: 'application/pdf' }));
        });
        this.cdr.detectChanges();
        // Pass copies to searchCoordinates: getDocument() transfers (detaches) the ArrayBuffer to the worker
        const pdfsForCoords = this.pdfs.map(d => ({ ...d, pdf: d.pdf instanceof Uint8Array ? d.pdf.slice() : d.pdf }));
        try {
          await this.pdfService.searchCoordinates(pdfsForCoords);
          // Copy coord results back to originals (searchCoordinates writes to the copies)
          pdfsForCoords.forEach((copy, i) => { this.pdfs[i].coord = copy.coord; });
        } catch (coordinateError) {
          console.error('PDF rendered but coordinate extraction failed', coordinateError);
        }
        this.renderFields(data);
        this.cdr.detectChanges();
        resolve(true);
      }, err => {
        this.toastr.error(this.translateService.instant('sign.pdf_get_error'));
        reject();
      });
    })
  }

  retrieveUserData() {
    this.currentUser = JSON.parse(localStorage.getItem("user"));
    this.currentLocation = this.currentUser.locationRoles[this.currentUser.selectedLocationIndex];
    this.today = this.currentLocation.Language ? moment().locale(this.currentLocation.Language).format('DD-MMM-YYYY HH:mm') : moment().format('DD-MMM-YYYY HH:mm');
  }

  @ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;

  trackByPdfUrl(index: number, doc: any): string {
    return doc.pdfUrl || doc.docId;
  }

  scrollToPage(page: number) {
    this.pdfComponent.pdfViewer.scrollPageIntoView({
      pageNumber: page
    });
  }

  // signPage = 7;
  renderFields(docs) {
    docs.forEach(doc => {
      if (doc.SignType.LocationId === 1 && !!doc?.Signers?.length) {
        if(doc.Status.toLowerCase() === 'signed') this.postSign = true;
        // const signPage = doc.coord?.find(a => Object.keys(a.items).length);
        // if (!!signPage) {
        // //    this.signPage = signPage.page;
        // }
        const userNom = doc.Signers.find(s => this.authService.compareUsr(s));
        if (!['rejected', 'signed'].includes(doc.Status.toLowerCase()) && !!userNom && userNom.Status.toLowerCase() !== 'signed') {
          //this.showNominateSign = true;
          //this.requiredNominateSign = true;
          //this.requiredNominatePrintName = true;
          //this.showNominatePrintName = true;
          //this.nominatePrintName = this.currentUser.name.toUpperCase();

          if(this.signList.find(x => x.type == 'nominate') == undefined) {
            this.signList.push({ 
              type: "nominate", 
              printName: this.currentUser.name.toUpperCase(), 
              isRequiredSign: true, 
              isRequiredPrintName: true,
              showSign: true,
              showPrintName: true
            });
          }
        }

        return;
      }

      var config: any =  {};

      doc.SignType.Fields.forEach(f => {
        var entity = '';
        switch(f.TypeEntity){
          case TypeEntity.EbolOrigin:
            entity = 'tenaris'; 
            break;
          case TypeEntity.EbolDriverOrigin:
            entity = 'driver'; 
            break;
        }

        config[entity] = config[entity] || {};
        config[entity].typeEntity = f.TypeEntity;
        
        switch(f.Type){
          case 'text':
            config[entity].isRequiredPrintName = f.Required;
            config[entity].showPrintName = true;
          break;
          case 'img':
            config[entity].isRequiredSign = f.Required;
            config[entity].showSign = true;
          break;
          case 'date':
            config[entity].showDate = false;
          break;
        }
      });

      Object.entries(config).forEach((x: Array<any>) => {
        if(this.signList.find(y => y.type.toLowerCase() == x[0].toLowerCase()) == undefined) {
        this.signList.push({ type: x[0], ...x[1] });
        }
      })
      
      this.signList.sort((a, b) => (a.type > b.type) ? 1 : -1);
    });
  }

  successfullySigned(content) {
    this.signed = true;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  closeModal() {
    this.modalService.dismissAll('Closed');
    setTimeout(() => {
      this.container.nativeElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }, 66);
  }

  getSign(data: Sign) {
    var index = this.signList.findIndex(x => (x.type == data.type) );
    
    if(index >= 0) {
      this.signList[index].sign =  data.sign;
      this.signList[index].subType =  data.subType;
      this.signList[index].contentType = data.contentType;
    }
  }

  goSign() {
    this.sign.nativeElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  checkDocSigners(onSend: boolean = false) {
    return new Promise((resolve, reject) => {
      const checked = this.documentsService.getDocumentsValue().filter(d => d.checked).map(d => d.Id);

      let requestConfig = this.filterService.getFiltersRequest();
      if (!requestConfig) {
        requestConfig = {
          ...requestConfig, ...{
            filters: [],
            fromDate: moment().format(),
            signed: 0,
            toDate: moment().format(),
            scan: ""
          }
        };
      }
      this.documentsService.getDocuments(requestConfig).subscribe(async data => {
        if (checked.length > 0) {
          checked.forEach(id => {
            const document = data.find(d => d.Id === id);
            if (document) document.checked = true;
          });
        }

        if (this.documents[0].Signers.filter(s => s.Status.toLowerCase() === 'signed').length < data[0]['Signers'].filter(s => s.Status.toLowerCase() === 'signed').length) {
          this.documents = data;
          this.initData().then(async data => {
            if (onSend) {
              await this.stampPdf();
            }
            resolve(true);
          });
        }
        else {
          resolve(true);
        }
      },
        err => {
          reject();
        });
    })
  }

  async stampSignatures() {
    this.spinner.show();
    //if (this.showNominateSign) {
    if (this.signList.filter(x => x.type == 'nominate').length > 0) {
      await this.checkDocSigners();
    }
    this.stampPdf().then();
  }

  async stampPdf() {
        return new Promise((resolve, reject) => {
          
          let isNominateSign = this.signList.filter(x => x.type == 'nominate').length > 0;
        
          this.pdfService.stampSignatures(this.pdfs, this.signList, isNominateSign, this.signAll, false).then(response => {
            response.forEach(sign => {
              const idx = this.pdfs.findIndex(doc => doc.docId === sign.docId);
              if (idx !== -1) {
                this.pdfs[idx].pdf = sign.pdf;
                this.pdfs[idx].pdfUrl = URL.createObjectURL(new Blob([sign.pdf], { type: 'application/pdf' }));
              }
            });
            this.spinner.hide();
            this.cdr.detectChanges();
            // ngx-spinner overlay remains in DOM with position:fixed after fade-out, blocking pointer events
            const overlay = document.querySelector('.ngx-spinner-overlay') as HTMLElement;
            if (overlay) overlay.style.pointerEvents = 'none';
            document.body.style.overflow = '';
            this.onPreview = true;
            resolve(true);
          }).catch(err => {
            this.spinner.hide();
            this.cdr.detectChanges();
            const overlay = document.querySelector('.ngx-spinner-overlay') as HTMLElement;
            if (overlay) overlay.style.pointerEvents = 'none';
            document.body.style.overflow = '';
            this.toastr.error(this.translateService.instant('sign.pdf_sign_error'));
            reject();
            throw Error(err);
        });
      })
  }

  async sendSignedDocs() {
    this.errorDiagnosticService.setMethodName('SignComponent.sendSignedDocs()');
    //if (this.showNominateSign) {
    if (this.signList.filter(x => x.type == 'nominate').length > 0) {
      await this.checkDocSigners(true);
    }

    const docs = this.pdfs.filter(p => 
      this.documents.filter(d => 
        d.Id === p.docId && 
        !p.signed && !d.isMtc ||
        d.isMtc && !!p['Signers'].find(s => s['Status'].toLowerCase() !== 'signed' && this.authService.compareUsr(s))
        )
    );

    if (docs.length === 0) {
      this.toastr.info(this.translateService.instant('sign.pdf_already_signed'));
      return;
    }

    this.sending = true;
    this.spinner.show();
    this.documentsService.sendSignedDocuments(docs).subscribe(data => {
      if (data.err.length > 0) this.toastr.error(this.translateService.instant('sign.pdf_sign_some_errors'));

      if (data.success.length > 0) this.documentsService.markDocumentsSigned(data.success, this.currentUser, this.pdfs).subscribe(data => {
        this.documents = data;
      });

      this.toastr.success(this.translateService.instant('sign.pdf_sign_success'));
      this.postSign = true;
      this.sending = false;
      this.spinner.hide();
    }, err => {
      this.sending = false;
      this.spinner.hide();
      this.toastr.error(this.translateService.instant('sign.pdf_sign_error'));
    });
  }

  createSign(content, current) {
    this.signed = false;
    this.currentSign = current;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  goBack(toLanding: boolean = false) {
    if( toLanding && this.appService.getCurrentRegion().toUpperCase() !== 'MTC')
      this.router.navigateByUrl('/');
    else
      this.location.back();
  }

  checkVisibilityFields() {
   return this.signList.filter(x => x.showSign || x.showPrintName || x.showDate).length > 0;
  }

  download(docs: any[] = []) {
    if (!!docs.length) {
      this.getDownloadDoc();
      // this.pdfService.downloadPdfs(docs);
      return;
    }

    const pdfs = this.filterSigned('download');
    if (!!!pdfs.length) return;
    // this.pdfService.downloadPdfs(pdfs);
    this.getDownloadDoc();
  }

  email() {
    const docIds = this.documentsService.getCheckedDocIds();
    if(!!docIds.length) {
      this.mailSender.open();
    } else {
      this.toastr.info(this.translateService.instant('mail_sender.cannot_send'));
    }
  }

  sendDocs(mails) {
    this.loading = true;
    this.documentsService.emailSend(mails).subscribe(data => {
      this.loading = false;
      this.toastr.success(this.translateService.instant('mail_sender.success_send'));
      this.mailSender.close();
    }, err => {
      this.toastr.error(this.translateService.instant(err));
      this.loading = false;
    });
  }

  filterSigned(type: string = '') {
    const filteredDocs = this.pdfs;
    if (filteredDocs.length < this.documents.length) {
      this.toastr.info(this.translateService.instant(`components.${type}.not_signed`));
    }
    return filteredDocs;
  }

  async print() {
    const pdfs = this.filterSigned('print');
    if (!!!pdfs.length) return;

    this.spinner.show();
    const blob = await this.pdfService.getPdfBlobForPrinting(pdfs);
    this.blobPdfToPrint = blob as Blob;
    this.pdfToPrint = URL.createObjectURL(blob as Blob);
    console.log(this.pdfToPrint);
    this.spinner.hide();

    if (this.appService.mobileCheck()) {
      this.toastr.info(this.translateService.instant('components.print.downloading_doc'));
      window.open(this.pdfToPrint);
    }
    else if (typeof window["InstallTrigger"] !== 'undefined') {
      this.pdfViewerOnDemand.pdfSrc = this.pdfToPrint;
      this.pdfViewerOnDemand.refresh();
    }
    else if (window.document['documentMode']) {
      (window.navigator as any).msSaveOrOpenBlob(blob);
    }
    else {
      this.renderer.listen(this.iframe.nativeElement, 'load', (e) => {
        this.iframe.nativeElement.contentWindow.print();
      });
    }
  }

  getDownloadDoc() {
    this.errorDiagnosticService.setMethodName('SignComponent.getDownloadDoc()');
    this.documentsService.getDocumentsPdf().subscribe(async data => {
        this.pdfService.downloadPdfs(data);
    }, err => {
      this.toastr.error(this.translateService.instant('search.download_request_error'));
    });
  }

  isSignedDocs() {
    this.allSigned = !this.documents.filter(d => !d.Signed).length;
  }

  canSignAllPages(){    
    this.signAllPages = this.documents.some(d => d.SignType.Fields.some(f => f.ApplyAllPage));
  }

}
